import { deviceAliases } from '../core/state';
import { esc } from '../ui/modal';
import { t } from '../ui/lang';
/** "Device Access" farm-settings tab — operator↔device whitelist matrix. */
export async function renderAccessTab(panel, farmId) {
    panel.innerHTML = `
        <p class="settings-hint">${t('farms.access_hint')}</p>
        <div class="access-loading">${t('common.loading')}</div>
        <div class="access-matrix-wrap" style="display:none"></div>
        <div class="settings-error modal__error" style="display:none"></div>
        <div class="settings-actions"><button type="button" class="modal__submit access-save" style="display:none">${t('common.save')}</button></div>
    `;
    const loadingEl = panel.querySelector('.access-loading');
    const wrapEl = panel.querySelector('.access-matrix-wrap');
    const errorEl = panel.querySelector('.settings-error');
    const saveBtn = panel.querySelector('.access-save');
    let accessData;
    try {
        const r = await fetch(`/api/farms/${farmId}/access`);
        if (!r.ok)
            throw new Error((await r.json()).error ?? t('common.failed_to_load'));
        accessData = await r.json();
    }
    catch (err) {
        loadingEl.style.display = 'none';
        errorEl.textContent = err.message;
        errorEl.style.display = 'block';
        return;
    }
    const { users, devices, restrictions } = accessData;
    loadingEl.style.display = 'none';
    if (users.length === 0) {
        wrapEl.style.display = 'block';
        wrapEl.innerHTML = `<p class="settings-hint">${t('farms.access_no_users')}</p>`;
        return;
    }
    const deviceLabel = (d) => deviceAliases.get(d.udid) || d.model || d.udid.slice(0, 12);
    const headerCells = devices.map((d) => `<th title="${esc(d.udid)}">${esc(deviceLabel(d))}</th>`).join('');
    const bodyRows = users.map((u) => {
        const allowed = restrictions[u.id]; // null = unrestricted, string[] = whitelist
        const cells = devices.map((d) => {
            const checked = allowed === null || (Array.isArray(allowed) && allowed.includes(d.udid));
            return `<td class="access-matrix__cell">
                <input type="checkbox" data-user="${u.id}" data-udid="${esc(d.udid)}" ${checked ? 'checked' : ''} />
            </td>`;
        }).join('');
        return `<tr><td class="access-matrix__user">${esc(u.login)}</td>${cells}</tr>`;
    }).join('');
    wrapEl.innerHTML = `
        <table class="access-matrix">
            <thead><tr><th>${t('farms.col_user')}</th>${headerCells}</tr></thead>
            <tbody>${bodyRows}</tbody>
        </table>
    `;
    wrapEl.style.display = 'block';
    saveBtn.style.display = '';
    saveBtn.addEventListener('click', async () => {
        saveBtn.disabled = true;
        errorEl.style.display = 'none';
        try {
            for (const u of users) {
                const checkboxes = wrapEl.querySelectorAll(`input[type="checkbox"][data-user="${u.id}"]`);
                const checkedUdids = [];
                checkboxes.forEach((cb) => { if (cb.checked)
                    checkedUdids.push(cb.dataset['udid']); });
                const allChecked = checkedUdids.length === devices.length;
                const udids = allChecked ? null : checkedUdids;
                const r = await fetch(`/api/farms/${farmId}/access/users/${u.id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ udids }),
                });
                if (!r.ok)
                    throw new Error((await r.json()).error ?? t('common.failed_to_save'));
            }
            const original = saveBtn.textContent;
            saveBtn.textContent = t('common.saved');
            setTimeout(() => { saveBtn.textContent = original; }, 1500);
        }
        catch (err) {
            errorEl.textContent = err.message;
            errorEl.style.display = 'block';
        }
        finally {
            saveBtn.disabled = false;
        }
    });
}
